/* Stay Dangerous — minimal theme JS */
(function () {
  // Mobile nav toggle
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sd-toggle]');
    if (!t) return;
    var sel = t.getAttribute('data-sd-toggle');
    var el = document.querySelector(sel);
    if (el) el.classList.toggle('is-open');
  });

  // Variant size selection — auto-update product form variant id
  document.querySelectorAll('[data-variant-radios]').forEach(function (root) {
    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"][data-variant-id]')) {
        var form = root.closest('form');
        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = e.target.getAttribute('data-variant-id');
        }
      }
    });
  });

  // Newsletter inline form (Shopify customer form)
  // No JS required — Shopify's {% form 'customer' %} handles submission
})();
